import { render, staticRenderFns } from "./ProspectLookupResult.vue?vue&type=template&id=5dcbf8a3&scoped=true&"
import script from "./ProspectLookupResult.vue?vue&type=script&lang=js&"
export * from "./ProspectLookupResult.vue?vue&type=script&lang=js&"
import style0 from "./ProspectLookupResult.vue?vue&type=style&index=0&id=5dcbf8a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbf8a3",
  null
  
)

export default component.exports